(() => {
  const attached = new WeakSet();
  function attach(modal) {
    if (attached.has(modal)) return;
    attached.add(modal);
    let wasOpen = false;
    function sync() {
      const title = modal.querySelector('#jdgm-review-title-input');
      const body = modal.querySelector('#jdgm-review-body-input');
      const titleGroup = title && title.closest('.jdgm-write-review-modal__field-group');
      const bodyGroup = body && body.closest('.jdgm-write-review-modal__field-group');
      if (titleGroup && bodyGroup && titleGroup.parentElement === bodyGroup.parentElement &&
          bodyGroup.previousElementSibling !== titleGroup) {
        bodyGroup.parentElement.insertBefore(titleGroup, bodyGroup);
      }
      const open = getComputedStyle(modal).display !== 'none' && !modal.hidden;
      if (open && !wasOpen && modal.getAttribute('data-current-page') === '1') {
        modal.querySelectorAll('.jdgm-write-review-modal__stars').forEach(group => {
          group.querySelectorAll('.jdgm-star').forEach(star => {
            star.classList.remove('jdgm--on', 'jdgm--half');
            star.classList.add('jdgm--off');
            star.setAttribute('aria-pressed', 'false');
          });
          group.querySelectorAll('input[name="score"]').forEach(input => {
            input.value = '';
          });
        });
      }
      wasOpen = open;
    }
    sync();
    new MutationObserver(sync).observe(modal, {
      childList: true, subtree: true, attributes: true,
      attributeFilter: ['style', 'data-current-page', 'hidden']
    });
    modal.addEventListener('click', event => {
      if (!event.target.closest('.jdgm-star')) return;
      requestAnimationFrame(() => modal.querySelectorAll('.jdgm-star').forEach(star => {
        star.setAttribute('aria-pressed', String(star.classList.contains('jdgm--on')));
      }));
    });
  }
  function scan() { document.querySelectorAll('.jdgm-write-review-modal').forEach(attach); }
  function start() {
    scan();
    new MutationObserver(scan).observe(document.body, {childList:true, subtree:true});
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, {once:true});
  else start();
})();